<template>
    <div class="row">
      <div class="col-lg-12">
        <h1 class="page-header">Importar Compromissos</h1>
  
        <!-- Seleção do período -->
        <div class="form-group col-sm-4">
          <label class="custom-font">Período</label>
          <select class="form-control" v-model="periodo">
            <option disabled value="">Selecione o período</option>
            <option v-for="p in periodos" :key="p" :value="p">{{ p }}</option>
          </select>
        </div>
  
        <!-- Upload do CSV -->
        <div class="form-group col-sm-8">
          <label class="custom-font">Arquivo CSV</label>
          <input ref="file" type="file" class="form-control" accept=".csv" @change="handleFile" />
        </div>
  
        <!-- Tabela de pré-visualização -->
        <div class="col-xs-12" v-if="compromissosValidos.length">
          <h3>Pré-visualização</h3>
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>Unidade</th>
                <th>Compromisso</th>
                <th>Responsável</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in compromissosValidos" :key="index">
                <td>{{ index + 1 }}</td>
                <td>{{ item.unidade_executora }}</td>
                <td>{{ item.descritivo }}</td>
                <td class="text-center">{{ item.responsavel_sshd }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-xs-12" v-if="compromissosInvalidos.length">
          <div class="alert alert-danger">
            <strong>Atenção!</strong> Foram encontrados {{ compromissosInvalidos.length }} compromissos com unidades inválidas. Eles não serão importados. Por favor, corrija o arquivo e envie novamente.
          </div>
          <h3>Compromissos com Unidades Inválidas</h3>
          <table class="table table-bordered table-striped">
            <thead>
              <tr>
                <th>#</th>
                <th>Unidade Original</th>
                <th class="coluna-unidade-corrigida">Unidade Corrigida</th>
                <th>Compromisso</th>
                <th>Responsável</th>
                <th>Ações</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(item, index) in compromissosInvalidos" :key="index">
                <td>{{ index + 1 }}</td>
                <td>
                  {{ item.unidade_executora }}
                </td>
                <td class="coluna-unidade-corrigida">
                  <select 
                    class="form-control select-selected"
                    v-model="item.nova_unidade_executora"
                  >
                    <option disabled value="">Selecione a unidade</option>

                    <optgroup label="Secretarias">
                      <option v-for="s in listas.secretarias" :key="s.sigla" :value="s.sigla" :title="s.nome">
                        {{ s.sigla }}
                      </option>
                    </optgroup>

                    <optgroup label="Autarquias">
                      <option v-for="a in listas.autarquias" :key="a.sigla" :value="a.sigla" :title="a.nome">
                        {{ a.sigla }}
                      </option>
                    </optgroup>
                  </select>
                </td>
                <td>{{ item.descritivo }}</td>
                <td class="text-center">{{ item.responsavel_sshd }}</td>
                <td>
                  <button 
                    class="btn btn-default"
                    title="Confirmar Correção"
                    @click="corrigirUnidade(item, index)"
                    :disabled="!item.nova_unidade_executora"
                  >
                    <font-awesome-icon :icon="'check'" />
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="col-xs-12" v-if="compromissosValidos.length || compromissosInvalidos.length">
          <div class="button-wrapper">
            <button 
              class="btn btn-danger"
              @click="reset"
              :disabled="!compromissosValidos.length && !compromissosInvalidos.length"
            >
              <font-awesome-icon :icon="'trash'" /> LIMPAR
            </button>

            <button 
              class="btn btn-default" 
              @click="salvar"
              :disabled="compromissosInvalidos.length > 0 || !compromissosValidos.length"
            >
              <font-awesome-icon :icon="'save'" /> IMPORTAR
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>

<script>
import Papa from 'papaparse' 
import { request } from '@/request'

export default {
  name: 'compromisso-importar',
  data() {
    return {
      periodo: '',
      periodos: ['2025-2028'],
      compromissosValidos: [],
      compromissosInvalidos: [],
      listas: {
        secretarias: [],
        autarquias: []
      },
    }
  },
  created() {
    this.loadUnidades();
  },
  methods: {
    async loadUnidades() {
      try {
        const { data: { data: secretarias } } = await request.get('listar-secretarias')
        const { data: { data: autarquias } } = await request.get('listar-autarquias')
  
        this.listas.secretarias = secretarias
        this.listas.autarquias = autarquias
      } catch (err) {
        this.$toastr.e('Erro ao carregar unidades. Verifique sua conexão e tente novamente.')
      }
    },
    async extrairUnidades(comp) {
      if (!comp.length) return

      const uniqueUnidades = [...new Set(comp.map(item => item.unidade_executora))];

      try {
        const { data, status } = await request.get('unidade-organizacional/siglas', {
          params: { siglas: uniqueUnidades }
        })

        if (status !== 200) {
          this.$toastr.e('Não foi possível validar as unidades do servidor.')
          return
        }

        const unidadesMap = new Map(data.map(unidade => [unidade.sigla, unidade.nome]))

        comp.forEach(compromisso => {
            if (unidadesMap.has(compromisso.unidade_executora)) {
                compromisso.nome_unidade_executora = unidadesMap.get(compromisso.unidade_executora);
                this.compromissosValidos.push(compromisso);
            } else {
                compromisso.nova_unidade_executora = '';
                this.compromissosInvalidos.push(compromisso);
            }
        });
      } catch (err) {
        console.error('Falha ao buscar unidades:', err)
        this.$toastr.e('Erro ao buscar unidades. Verifique sua conexão e tente novamente.')
      }
    },
    handleFile(event) {
      const file = event.target.files[0]
      if (!file) return

      this.reset(); 

      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: (result) => {
          const compromissosDoArquivo = result.data.map(row => ({
            unidade_executora: row['unidade'],
            descritivo: row['compromisso'],
            responsavel_sshd: row['responsavel']
          }))
          this.extrairUnidades(compromissosDoArquivo);
        }
      })
    },
    corrigirUnidade(item, index) {
      const novaSigla = item.nova_unidade_executora;
      const todasUnidades = [...this.listas.secretarias, ...this.listas.autarquias]
      const unidadeSelecionada = todasUnidades.find(u => u.sigla === novaSigla)

      if (unidadeSelecionada) {
        item.unidade_executora = novaSigla;
        item.nome_unidade_executora = unidadeSelecionada.nome;

        delete item.nova_unidade_executora;

        this.compromissosValidos.push(item);
        this.compromissosInvalidos.splice(index, 1);

        this.$toastr.s('Unidade corrigida com sucesso.');
      }
    },
    reset() {

      if (this.$refs.file) {
        this.$refs.file.value = '';
      }
      
      this.compromissosValidos = [];
      this.compromissosInvalidos = [];
    },
    async salvar() {
      if (!this.periodo || !this.compromissosValidos.length) {
        this.$toastr.e('Selecione o período e carregue um arquivo válido.')
        return
      }

      const { periodo } = this
      const compromissos = this.compromissosValidos;
      const { status } = await request.post('planogoverno/compromisso', { periodo, compromissos })

      if (status != 201) return this.$toastr.e('Houve um problema na importação dos compromissos, tente novamente daqui a pouco!')

      this.$toastr.s('Compromissos importados com sucesso.')
      this.reset()
    },
  }
}
</script>

<style scoped>
.custom-font {
  color: #00615c;
  font-weight: bold;
}
.page-header {
  margin-top: 20px;
}

.button-wrapper {
    width: 100%;
    display:flex;
    justify-content: flex-end;
    gap: 10px;
}

.coluna-unidade-corrigida {
  min-width: 250px;
  vertical-align: middle !important;
}

.select-selected {
    color: #00615c;
}
</style>
  


// WEBPACK FOOTER //
// src/views/admin/plano-governo/compromisso/Importar.vue